/**
 * ChaptersRedirect — /chapters now redirects to /chapters/{currentYear}.
 *
 * Phase 1 (book redesign) reframed the aggregated year list as an entry
 * point instead of a destination. Users land straight on the current
 * year's book-page; other years live in the right-rail tabs.
 *
 * We keep the legacy <ChaptersPage> component in the tree (still
 * imported in App.js) so debug/admin sub-routes can reintroduce it
 * later without rewiring, but no public route points at it anymore.
 */
import React from "react";
import { Navigate } from "react-router-dom";

export default function ChaptersRedirect() {
  const currentYear = new Date().getFullYear();
  return <Navigate to={`/chapters/${currentYear}`} replace />;
}
